/**
 * AuthShell — the frame every signed-out screen shares (sign in, forgot password, choose a password):
 * brand panel on the left from `lg` up, the logo above the form below it.
 */
import type { ReactNode } from "react";
import { motion } from "framer-motion";
import { Logo } from "@/components/brand/Logo";

export function AuthShell({ title, subtitle, children }: { title: string; subtitle?: ReactNode; children: ReactNode }) {
  return (
    <div className="grid min-h-screen bg-white lg:grid-cols-2">
      <aside className="relative hidden items-center justify-center overflow-hidden bg-accent-900 lg:flex" aria-hidden="true">
        <Logo variant="full" tone="dark" className="relative w-[min(26rem,70%)]" title="" />
        <p className="absolute bottom-10 text-sm text-accent-300">© {new Date().getFullYear()} DemandHub Inc.</p>
      </aside>
      <main className="flex items-center justify-center px-6 py-12 sm:px-10">
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
          className="w-full max-w-[400px]"
        >
          <Logo variant="full" className="mb-10 h-9 w-auto lg:hidden" />
          <h1 className="text-3xl font-semibold text-neutral-900">{title}</h1>
          {subtitle && <p className="mt-2 text-base text-neutral-600">{subtitle}</p>}
          {children}
        </motion.div>
      </main>
    </div>
  );
}
